module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/evaluate/assets/dark-star.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/evaluate/assets/dark-star.png
// module id = 1320
// module chunks = 418